import React, { useEffect, useState, createRef } from "react";
import "./Home.css";
import { gsap } from "gsap";
import HeaderBar from "../../components/HeaderBar";
import FollowBar from "../../components/FollowBar";

const Home = () => {
  const [isReady, setIsReady] = useState(false);
  const loadingImgRef = createRef();

  useEffect(() => {
    gsap
      .to(loadingImgRef.current, {
        opacity: 1,
        duration: 3,
        ease: "ease-in-out",
      })
      .then(() => setIsReady(true));
  }, []);

  return (
    <div className="outerContainer">
      {!isReady && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "white",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        >
          <img
            ref={loadingImgRef}
            alt="logo"
            loading="eager"
            src="/logo.png"
            style={{ height: "15rem", width: "15rem", opacity: 0 }}
          />
        </div>
      )}

      <div className="container">
        <HeaderBar title="" />
        <div className="homeDisplayArea">
          <div className="homeDisplayLeft">
            <h1>Winning Star Guessing</h1>
            <h4>Welcomes You</h4>
          </div>
          <div className="homeDisplayRight">soemt text</div>
        </div>
        <FollowBar />
      </div>
    </div>
  );
};

export default Home;
